














































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Route } from "vue-router";
import anime from "animejs";
import Empty from "./Empty.vue";
import actions from "../../store/constants";
import ScreensPagination from "../../components/ScreensPagination.vue";
import DesktopMenu from "../../components/DesktopMenu.vue";
import ScrollMagic from "scrollmagic";
import ZingTouch from "zingtouch";

import ObjectPageFirstScreen from "./ObjectPageFirstScreen.vue";
import ObjectPagePlan from "./ObjectPagePlan.vue";
import ObjectPageVizualizations from "./ObjectPageVizualizations.vue";
import ObjectPageAdvantages from "./ObjectPageAdvantages.vue";
import ObjectPageMaterials from "./ObjectPageMaterials.vue";
import ObjectPageMap from "./ObjectPageMap.vue";
import ObjectPageBuilding from "./ObjectPageBuilding.vue";
import ObjectPageContacts from "./ObjectPageContacts.vue";
import ObjectPagePanoramas from "./ObjectPagePanoramas.vue";

@Component({
  components: {
    ScreensPagination,
    DesktopMenu
  }
})
export default class ObjectPage extends Vue {
  screens = [
    ObjectPageFirstScreen,
    ObjectPagePlan,
    ObjectPageVizualizations,
    ObjectPageAdvantages,
    ObjectPageBuilding,
    ObjectPageMaterials,
    ObjectPagePanoramas,
    ObjectPageMap,
    ObjectPageContacts
  ];

  mobileScreens = [
    ObjectPageFirstScreen,
    ObjectPagePlan,
    ObjectPageVizualizations,
    ObjectPageAdvantages,
    ObjectPageBuilding,
    ObjectPageMap,
    ObjectPageContacts
  ];

  get screensToShow() {
    return this.scrollingByScreens ? this.screens : this.mobileScreens;
  }

  @Getter('pageBehindAWindow') pageBehindAWindow!: boolean;
  @State(state => state.app.isTouchscreen) isTouchscreen!: boolean;
  @State(state => state.app.loadingScreenActive) loadingScreenActive!: number;
  @State(state => state.app.loadingScreenAnimationEnded) loadingScreenAnimationEnded!: number;
  @State(state => state.app.moveDirection) moveDirection!: string;
  @State(state => state.app.activeHouseInformationWindow) activeHouseInformationWindow!: number;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  $refs!: {
    page: HTMLElement
  }

  pageActive = true;
  // Номер экрана к смене
  activeScreenNumber = 0;
  // Номер видимого экрана
  visibleScreenNumber = 0;
  // хранит номер экрана для дальнейшего возврата к нему при переходах по страницам.
  lastShowedScreen = 0;
  lastScreenSwitchTimestamp = 0;

  get screensNumber() {
    return this.screensToShow.length;
  }

  activated() {
    this.pageActive = true;

    if (!this.loadingScreenActive) {
      if (this.scrollingByScreens) {
        this.activeScreenNumber =
          this.lastShowedScreen > 0 ? this.lastShowedScreen : 1;
        this.changeScreen();
      }

      this.addScrollingControl();
    }
  }

  deactivated() {
    this.pageActive = false;
  }

  // Активирует работу экрана по моменту скрытия экрана загрузки
  @Watch("loadingScreenActive")
  onLoadingScreenHide() {
    if (this.scrollingByScreens) {
      if (this.activeScreenNumber < 1) {
        let nowTimestamp = new Date().getTime();
        this.lastScreenSwitchTimestamp = nowTimestamp;
        this.activeScreenNumber = 1;
        this.changeScreen();
      }
    }

    this.addScrollingControl();
  }

  /** Ожидание завершения анимаций перед уходом с страницы */
  /*beforeRouteLeave(to: Route, from: Route, next: VoidFunction) {
    this.activeScreenNumber = 0;
    let intervalSetTimestamp = new Date().getTime();
    let waitCheck = setInterval(() => {
      if (this.visibleScreenNumber == 0) {
        clearInterval(waitCheck);
        next();
      }
      if (new Date().getTime() - intervalSetTimestamp > 4000) {
        clearInterval(waitCheck);
        next();
      }
    }, 50);
  }*/

  changeScreen() {
    this.visibleScreenNumber = this.activeScreenNumber;
    // Сохраняем номер входящего экрана для дальнейшего возврата к нему при переходах по страницам.
    // Переменная lastShowedScreen хранит этот номер благодаря keep-alive
    if (this.activeScreenNumber !== 0)
      this.lastShowedScreen = this.activeScreenNumber;
  }

  /** Переход к следующему экрану */
  nextScreen() {
    if (this.moveDirection !== "prev") {
      this.$store.dispatch(actions.changeMoveDirection, "prev");
    }

    let nowTimestamp = new Date().getTime();
    if (nowTimestamp - this.lastScreenSwitchTimestamp > 2100) {
      if (this.screensNumber > this.activeScreenNumber) {
        this.lastScreenSwitchTimestamp = nowTimestamp;
        this.activeScreenNumber = this.activeScreenNumber + 1;
      }
    }
  }

  /** Переход к предыдущему экрану */
  prevScreen() {
    if (this.moveDirection !== "next") {
      this.$store.dispatch(actions.changeMoveDirection, "next");
    }

    let nowTimestamp = new Date().getTime();
    if (nowTimestamp - this.lastScreenSwitchTimestamp > 2100) {
      if (this.activeScreenNumber > 1) {
        this.lastScreenSwitchTimestamp = nowTimestamp;
        this.activeScreenNumber = this.activeScreenNumber - 1;
      }
    }
  }

  switchScreen(newScreen: number) {
    if (this.visibleScreenNumber > newScreen) {
      if (this.moveDirection !== "prev") {
        this.$store.dispatch(actions.changeMoveDirection, "prev");
      }
    }

    if (this.visibleScreenNumber < newScreen) {
      if (this.moveDirection !== "next") {
        this.$store.dispatch(actions.changeMoveDirection, "next");
      }
    }

    let nowTimestamp = new Date().getTime();
    if (nowTimestamp - this.lastScreenSwitchTimestamp > 2100) {
      this.lastScreenSwitchTimestamp = nowTimestamp;
      this.activeScreenNumber = newScreen;
    }
  }

  /** Устанавливает слушатели событий скролла */
  addScrollingControl() {
    let contentContainer = document.querySelector<HTMLElement>(".main-content");
    let ctrlPressed = false;
    let scrollEventsNumber = 0;

    document.addEventListener('keydown', function (event) {
      if (event.keyCode == 17) {
        ctrlPressed = true;
      }
    });

    document.addEventListener('keyup', function (event) {
      if (event.keyCode == 17) {
        ctrlPressed = false;
      }
    });

    if (this.scrollingByScreens) {
      contentContainer!.addEventListener("wheel", event => {
        if (ctrlPressed && this.activeScreenNumber == 7) {
          scrollEventsNumber = 0;
          return;
        }

        if (this.activeScreenNumber == 7 && scrollEventsNumber < 2) {
          scrollEventsNumber = scrollEventsNumber + 1;
        }

        if (this.pageActive && (this.activeScreenNumber !== 7 || scrollEventsNumber == 2)) {
          scrollEventsNumber = 0;
          if (event.deltaY! > 0) this.nextScreen();
          else if (event.deltaY! < 0) this.prevScreen();
        }
      });
    }

    if (!this.scrollingByScreens) {
      var controller = new ScrollMagic.Controller();
      let screens = this.$refs.page.querySelectorAll(".screen-wrap");
      for (let index = 0; index < screens.length; index++) {
        const screen = screens[index];
        new ScrollMagic.Scene({ triggerElement: screen, duration: "100%" })
          .addTo(controller)
          .on("enter", () => {
            let sn = index + 1;
            this.activeScreenNumber = sn;
            this.changeScreen();
          });
      }
    }

    if (this.scrollingByScreens && this.isTouchscreen) {
      // Слушатель событий свайпов
      var zt = new ZingTouch.Region(contentContainer, false, false);
      let swipe = new ZingTouch.Swipe({
        numInputs: 1,
        maxRestTime: 100,
        escapeVelocity: 0.25
      });
      zt.bind(contentContainer, swipe, (e: any) => {
        if (this.pageActive) {
          let direction = e.detail.data[0].currentDirection;
          if (direction > 220 && direction < 320) {
            this.prevScreen();
          } else if (direction > 50 && direction < 130) {
            this.nextScreen();
          }
        }
      },
        false
      );
    }
  }

  /** Предыдущий экран уходит.*/
  @Watch("activeScreenNumber")
  activeScreenNumberChange(nextNumber: number, prevNumber: number) {
    let shadowsBlock = this.$refs.page.querySelector<HTMLElement>(".shadows");
    if (nextNumber <= 2) {
      shadowsBlock!.classList.remove("deactive");
    } else {
      shadowsBlock!.classList.add("deactive");
    }
  }
}
